export default "__VITE_ASSET__DcJY1eiv__"